/**
 * @module themeSearch
 */

/**
 * Theme Search
*/

module.exports = function() {
    const searchInput = document.querySelector( '.theme-search-input' );
    const resultsContainer = document.querySelector( '.theme-search-results' );
    const resultsContainerInner = resultsContainer.querySelector( '.results-inner' );
    const keepTyping = resultsContainer.querySelector( '.keep-typing' );
    const ajaxUrl = searchInput.dataset.ajaxUrl;
    const postType = searchInput.dataset.postType;
    const typeDelay = 300;
    const showHideDelay = 200;
    const triggerLength = 4;

    let timer;

    searchInput.addEventListener( 'input', function() {
        const query = this.value;
        clearTimeout( timer );

        if ( ! query ) {
            resultsContainerInner.innerHTML = '';
            resultsContainer.classList.add( 'd-none' );
            return;
        }

        if ( query.length >= triggerLength ) {
            timer = setTimeout( () => {
                fetch( `${ajaxUrl}?action=ajax_search&term=${encodeURIComponent(query)}&post_type=${encodeURIComponent(postType)}` )
                    .then( ( res ) => res.text() )
                    .then( ( data ) => {
                        resultsContainerInner.innerHTML = data;
                        showResults();
                        hideKeepTyping();
                    } );
            }, typeDelay );
        } else if ( query.length < triggerLength && query.length > 0 ) {
            resultsContainerInner.innerHTML = '';
            showResults();
            showKeepTyping();
        } else {
            hideResults();
            hideKeepTyping();
        }
    } );

    document.addEventListener( 'click', function( e ) {
        // If the target is not in the document, do nothing
        if ( ! e.target || ! document.body.contains( e.target ) ) {
            return;
        }

        if ( ! searchInput.contains( e.target ) && ! resultsContainer.contains( e.target ) ) {
            hideResults();
        } else {
            showResults();
        }
    } );

    searchInput.addEventListener( 'blur', function() {
        hideResults();
    } );

    searchInput.addEventListener( 'focus', function() {
        const query = this.value.trim();
        if ( query.length >= triggerLength && resultsContainer.innerHTML.trim() !== '' ) {
            showResults();
        } else if ( query.length > 0 && query.length < triggerLength ) {
            showResults();
            showKeepTyping();
        } else {
            hideResults();
            hideKeepTyping();
        }
    } );

    function hideResults() {
        setTimeout( function() {
            resultsContainer.classList.add( 'd-none' );
        }, showHideDelay );
    }

    function showResults() {
        setTimeout( function() {
            resultsContainer.classList.remove( 'd-none' );
        }, showHideDelay );
    }

    function hideKeepTyping() {
        setTimeout( function() {
            keepTyping.classList.add( 'd-none' );
        }, showHideDelay );
    }

    function showKeepTyping() {
        setTimeout( function() {
            keepTyping.classList.remove( 'd-none' );
        }, showHideDelay );
    }
};
